import {
	useEffect,
} from 'react';
import {
	useOnline,
} from '.';
import {
	database,
} from 'utils/database';
import {
	http,
	HttpOptions,
	HttpRequestType,
	QueuedHttpRequest,
} from 'utils/http';

/**
 * Hook for syncing queued API calls, for devices that do not support background sync
 */
export const useSyncQueuedApiCalls = () => {
	const isOnline: boolean = useOnline();

	const performAPICall = (request: RequestInit, url: string, id: any, options: HttpOptions | undefined): Promise<unknown> => {
		switch (request.method) {
			case HttpRequestType.GET:
				return http.get(url, options);
			case HttpRequestType.POST:
				return http.post(url, request.body, options);
			case HttpRequestType.PUT:
				return http.put(url, request.body, options);
			case HttpRequestType.PATCH:
				return http.patch(url, request.body, options);
				/*
				* It has to be a string or number to begin with to get to this point
				* So it should be safe to cast it.
				*/
			case HttpRequestType.DELETE: // id is included in the url param
				return http.delete(url, id, options);
		}
		/**
     * We should never get here.
     * But if we do, we should resolve the promise and allow it to be deleted
     */
		return new Promise<any>((resolve) => resolve);
	};

	/**
	 * Check if there are any requests in the queue
	 * and attempt to perform them if we are online.
	 */
	const checkIfQueueContainsCallsAndDoUpdate = () => {
		if (database?.apiQueue && database.isOpen() && isOnline) {
			database.apiQueue.orderBy('timestamp').toArray()
				.then(async (queue: QueuedHttpRequest[]) => {
					for (const {
						id, timestamp, url, request, options,
					} of queue) {
						const opts = {
							...options,
							table: options?.table ? database[options?.table] : undefined,
						}
						await performAPICall(request, url, id, opts)
							.then(async () => {
								await database.apiQueue.delete(timestamp);
							});
					}
				})
				.catch(error =>
					console.error('useSyncQueuedApiCalls.apiQueue', error)
				);
		}
	};

	useEffect(() => {
		checkIfQueueContainsCallsAndDoUpdate();
	}, [isOnline]);
};